(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initBar(root) {
    var endStr = root.getAttribute('data-end-time');
    if (!endStr) return;
    var endTs = new Date(endStr).getTime();
    if (isNaN(endTs)) return;

    var onExpire = root.getAttribute('data-on-expire') || 'freeze';
    var timerEl = root.querySelector('[data-cb-timer]');
    var msgEl   = root.querySelector('[data-cb-expire-message]');
    var units   = Array.prototype.slice.call(root.querySelectorAll('.cb-unit'));

    function compute(now) {
      var diff = Math.max(0, endTs - now);
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      return { days: d, hours: h, minutes: m, seconds: s, diff: diff };
    }

    function setUnit(unitEl, value) {
      var str = pad(value);
      var srEl = unitEl.querySelector('[data-value]');
      if (srEl && srEl.textContent !== str) srEl.textContent = str;

      var cards = unitEl.querySelectorAll('.cb-card');
      if (cards.length === 2) {
        for (var i = 0; i < 2; i++) {
          var ch = str.charAt(i);
          if (cards[i].getAttribute('data-digit') !== ch) {
            cards[i].setAttribute('data-digit', ch);
            cards[i].textContent = ch;
            cards[i].classList.remove('is-flipping');
            // force reflow so animation restarts
            void cards[i].offsetWidth;
            cards[i].classList.add('is-flipping');
          }
        }
      }
    }

    function applyExpire() {
      if (onExpire === 'hide_section') {
        root.style.display = 'none';
      } else if (onExpire === 'show_message') {
        if (timerEl) timerEl.style.display = 'none';
        if (msgEl) msgEl.hidden = false;
      }
      // 'freeze' — leave the 00s in place
    }

    var expiredHandled = false;
    function tick() {
      var t = compute(Date.now());
      units.forEach(function (u) {
        var unit = u.getAttribute('data-unit');
        if (t.hasOwnProperty(unit)) setUnit(u, t[unit]);
      });
      if (t.diff <= 0 && !expiredHandled) {
        expiredHandled = true;
        applyExpire();
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-countdown-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when theme editor re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-countdown-bar]');
    if (root) initBar(root);
  });
})();
